/**
 * Map tiles & geocode fallback URLs for attendance premises UI.
 * Override via frontend `.env` (REACT_APP_* — see `.env.example`).
 */
const ATTENDANCE_MAP_CONFIG = Object.freeze({
  /** Reliable OSM tiles (Carto {r} URLs often show a blank grey map). */
  TILE_URL:
    process.env.REACT_APP_MAP_TILE_URL ||
    "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",

  TILE_ATTRIBUTION:
    process.env.REACT_APP_MAP_TILE_ATTRIBUTION ||
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',

  TILE_SUBDOMAINS: ["a", "b", "c"],

  PHOTON_API_URL:
    process.env.REACT_APP_GEOCODE_PHOTON_API_URL || "https://photon.komoot.io/api/",

  DEFAULT_CENTER_LAT: Number(process.env.REACT_APP_MAP_DEFAULT_LAT) || 17.385,
  DEFAULT_CENTER_LNG: Number(process.env.REACT_APP_MAP_DEFAULT_LNG) || 78.4867,
});

export default ATTENDANCE_MAP_CONFIG;
